"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.MyAccountSaleStore = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _head2 = _interopRequireDefault(require("lodash/head"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _cartProduct = require("@tajawal/web-core-sdk-v2/lib/utils/cart-product.utils");
var _sale = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/sale.store"));
var _flightProduct = _interopRequireWildcard(require("@tajawal/web-flights-sdk/lib/factories/flight-product.factory"));
var _sale2 = require("../clients/sale.client");
var _orderContact = require("../factories/order-contact.factory");
var _constants2 = require("../constants");
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
const {
  INITIAL,
  LOADING,
  SUCCESS,
  FAILED
} = _constants.API_STATE;
let MyAccountSaleStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class = /*#__PURE__*/function (_SaleStore) {
  (0, _inherits2.default)(MyAccountSaleStore, _SaleStore);
  var _super = _createSuper(MyAccountSaleStore);
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function MyAccountSaleStore(initialState = {}, $env, makeProductFactory, productType) {
    var _this;
    (0, _classCallCheck2.default)(this, MyAccountSaleStore);
    _this = _super.call(this, initialState, $env, makeProductFactory);
    (0, _initializerDefineProperty2.default)(_this, "data", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "API_STATE", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    /**
     * set sale data
     * @param data
     */
    (0, _initializerDefineProperty2.default)(_this, "setSaleData", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    /**
     * get sale object by saleNumber and saleId or contact email
     * @param {object} prop
     * @param {string} prop.payload
     * @param {string} prop.payload.saleNumber
     * @param {string} prop.payload.saleId
     * @param {string} prop.payload.contactEmail
     * @param {Function} [prop.errorHandler]
     */
    (0, _initializerDefineProperty2.default)(_this, "getSale", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    /**
     * get sale object by saleNumber and saleId
     * @param {object} prop
     * @param {string} prop.payload
     * @param {string} prop.payload.saleId
     * @param {string} prop.payload.saleNumber
     * @param {Function} [prop.errorHandler]
     * @param {Function} [prop.successHandler]
     */
    (0, _initializerDefineProperty2.default)(_this, "getSalePolling", _descriptor5, (0, _assertThisInitialized2.default)(_this));
    _this.$env = $env;
    _this.makeProductFactory = makeProductFactory;
    _this.productType = productType;
    _this.updateInitialState(initialState);
    return _this;
  }
  (0, _createClass2.default)(MyAccountSaleStore, [{
    key: "isSaleLoading",
    get:
    /**
     * is loading
     * @return {boolean}
     */
    function () {
      return this.API_STATE === LOADING;
    }

    /**
     * is fetched
     * @return {boolean}
     */
  }, {
    key: "isSaleFetched",
    get: function () {
      return this.API_STATE === SUCCESS;
    }

    /**
     * is error
     * @return {boolean}
     */
  }, {
    key: "hasSaleError",
    get: function () {
      return this.API_STATE === FAILED;
    }

    /**
     * modified cart id (TODO - decide which to keep cartId or modifiedCartId based on product alignment)
     * @return {string}
     */

    /**
     * valid products
     * @return {Array<Object>}
     */
  }, {
    key: "booking",
    get: function () {
      // check the this.data.bookings

      return this.data.bookings && this.data.bookings.find(item => item.orderNumber === this.currentOrderNumber);
    }

    /**
     * order displayStatus code
     * @return {number}
     */
  }, {
    key: "displayStatus",
    get: function () {
      return (0, _get2.default)(this.booking, 'displayStatus');
    }

    /**
     * order status code
     * @return {number}
     */
  }, {
    key: "status",
    get: function () {
      return (0, _get2.default)(this.booking, 'status');
    }

    /**
     * contact
     * @return {Object}
     */
  }, {
    key: "contact",
    get: function () {
      return (0, _orderContact.orderContactFactory)((0, _get2.default)(this.booking, 'contact'));
    }

    /**
     * payment method
     * @return {string}
     */
  }, {
    key: "paymentMethod",
    get: function () {
      return (0, _get2.default)(this.booking, 'payment.paymentMethod');
    }

    /**
     * reward method
     * @return {string}
     */
  }, {
    key: "rewardMethod",
    get: function () {
      return (0, _get2.default)(this.booking, 'additionalData.loyalty.reward.method', '');
    }

    /**
     * reward value
     * @return {number}
     */
  }, {
    key: "rewardValue",
    get: function () {
      return (0, _get2.default)(this.booking, 'additionalData.loyalty.reward.rewardValue', 0);
    }

    /**
     * reward points
     * @return {number}
     */
  }, {
    key: "rewardPoints",
    get: function () {
      return (0, _get2.default)(this.booking, 'additionalData.loyalty.reward.rewardPoints', this.rewardValue);
    }

    /**
     * reward points
     * @return {string}
     */
  }, {
    key: "rewardExpiryDate",
    get: function () {
      return (0, _get2.default)(this.booking, 'additionalData.loyalty.reward.rewardExpiryDate', '');
    }

    /**
     * reward identifier
     * @return {string}
     */
  }, {
    key: "rewardIdentifier",
    get: function () {
      return (0, _get2.default)(this.booking, 'additionalData.loyalty.reward.identifier', '');
    }
  }, {
    key: "card",
    get: function () {
      return (0, _get2.default)(this.booking, 'payment.card');
    }

    /**
     * list of products
     * @return {number}
     */
  }, {
    key: "products",
    get: function () {
      return (0, _get2.default)(this.booking, 'products', []);
    }

    /**
     * valid products
     * @return {Array<Object>}
     */
  }, {
    key: "validProducts",
    get: function () {
      return this.products.filter(_cartProduct.isValidProduct);
    }

    /**
     * raw product
     * @return {Object}
     */
  }, {
    key: "rawProduct",
    get: function () {
      var _this$validProducts;
      return (0, _last2.default)((_this$validProducts = this.validProducts) === null || _this$validProducts === void 0 ? void 0 : _this$validProducts.filter(item => item.type === this.booking.type));
    }
  }, {
    key: "product",
    get: function () {
      if (this.validProducts.length > 0) {
        if (this.booking.type === _constants2.PRODUCT_TYPES.FLIGHT) {
          var _this$rawProduct, _this$rawProduct$opti;
          if ((_this$rawProduct = this.rawProduct) !== null && _this$rawProduct !== void 0 && (_this$rawProduct$opti = _this$rawProduct.options) !== null && _this$rawProduct$opti !== void 0 && _this$rawProduct$opti.isMultiPNR) {
            return (0, _flightProduct.combineFlightProducts)(this.validProducts.filter(product => product.type === 'flight').map(product => this.makeProductFactory({
              flightProduct: product,
              $currency: this.$env.currency
            })), this.$env.currency);
          }
          return this.makeProductFactory({
            flightProduct: this.rawProduct,
            $currency: this.$env.currency
          });
        }
        return this.makeProductFactory(this.rawProduct);
      }
      return {};
    }
  }, {
    key: "payment",
    get: function () {
      var _this$data, _this$data2, _this$data2$payments;
      if ((_this$data = this.data) !== null && _this$data !== void 0 && _this$data.payments && ((_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : (_this$data2$payments = _this$data2.payments) === null || _this$data2$payments === void 0 ? void 0 : _this$data2$payments.length) > 0) {
        var _this$data3;
        return (_this$data3 = this.data) === null || _this$data3 === void 0 ? void 0 : _this$data3.payments[0];
      }
      return null;
    }

    /**
     * modified cart id (TODO - decide which to keep cartId or modifiedCartId based on product alignment)
     * @return {string}
     */
  }, {
    key: "modifiedCartId",
    get: function () {
      return (0, _get2.default)(this.booking, 'additionalData.cartId');
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "onSuccess",
    value:
    /**
     * handle success
     * @param {Object} data
     */
    function onSuccess(data, successHandler) {
      this.setSaleData(data);
      this.API_STATE = SUCCESS;
      successHandler && successHandler(data);
    }

    /**
     * handle error
     * @param {Object} error
     * @param {Function} errorHandler
     */
  }, {
    key: "onError",
    value: function onError(error, errorHandler) {
      errorHandler(error);
      this.API_STATE = FAILED;
    }
  }]);
  return MyAccountSaleStore;
}(_sale.default), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return INITIAL;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSaleLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSaleLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSaleFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSaleFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasSaleError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSaleError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "booking", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "booking"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayStatus", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayStatus"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "status", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "status"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "contact", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contact"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paymentMethod", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentMethod"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardMethod", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardMethod"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardValue"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardPoints", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardPoints"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardExpiryDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardExpiryDate"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardIdentifier", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardIdentifier"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "card", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "card"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "products", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "products"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "validProducts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "validProducts"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rawProduct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rawProduct"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "product", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "product"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "payment", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "payment"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "modifiedCartId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "modifiedCartId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSaleData", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return function setSale(data) {
      this.data = data;
    };
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "getSale", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* getSale({
      id,
      saleNumber,
      contactEmail,
      productType,
      errorHandler = () => null,
      successHandler = () => null
    }) {
      this.API_STATE = LOADING;
      try {
        const response = yield _sale2.SaleClient.getSale(saleNumber, id, contactEmail);
        if (productType) {
          this.currentOrderNumber = saleNumber;
        }
        this.onSuccess(response, successHandler);
      } catch (e) {
        console.log({
          e
        });
        this.onError(e, errorHandler);
      }
    });
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "getSalePolling", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* getSalePolling({
      id,
      saleNumber,
      errorHandler = () => null,
      successHandler = () => null
    }) {
      try {
        const response = yield _sale2.SaleClient.getSale(saleNumber, id);
        successHandler === null || successHandler === void 0 ? void 0 : successHandler(response);
      } catch (e) {
        errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(e);
      }
    });
  }
})), _class));
exports.MyAccountSaleStore = MyAccountSaleStore;